// 4. Composant de navigation entre étapes
// components/consultation/StepNavigation.tsx
import React from 'react';

interface StepNavigationProps {
  currentStep: number;
  totalSteps: number;
  onPrevious?: () => void;
  onNext?: () => void;
  nextLabel?: string;
  previousLabel?: string;
  showPrevious?: boolean;
  showNext?: boolean;
  loading?: boolean;
}

export const StepNavigation: React.FC<StepNavigationProps> = ({
  currentStep,
  totalSteps,
  onPrevious,
  onNext,
  nextLabel = "Suivant",
  previousLabel = "Précédent",
  showPrevious = true,
  showNext = true,
  loading = false,
}) => {
  return (
    <div className="flex justify-between items-center mt-8 pt-6 border-t border-gray-200">
      <div className="flex items-center space-x-2">
        {Array.from({ length: totalSteps }, (_, i) => (
          <div
            key={i}
            className={`w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full ${
              i + 1 <= currentStep
                ? 'bg-blue-600'
                : 'bg-gray-300'
            }`}
          />
        ))}
        <span className="text-sm text-gray-500 ml-3">
          Étape {currentStep} sur {totalSteps}
        </span>
      </div>

      <div className="flex gap-4">
        {showPrevious && currentStep > 1 && (
          <button
            type="button"
            className="px-6 py-2 bg-gray-500 text-white rounded-xl font-semibold shadow hover:bg-gray-600 transition disabled:opacity-50"
            onClick={onPrevious}
            disabled={loading}
          >
            {previousLabel}
          </button>
        )}
        
        {showNext && (
          <button
            type="button"
            className="px-6 py-2 bg-blue-600 text-white rounded-xl font-semibold shadow hover:bg-blue-700 transition disabled:opacity-50"
            onClick={onNext}
            disabled={loading}
          >
            {loading ? 'Chargement...' : nextLabel}
          </button>
        )}
      </div>
    </div>
  );
};